import React from 'react'
import RichMultiText from 'molecules/display/RichMultiText'
import RichTitle from 'molecules/display/RichTitle'
import Card from 'atoms/surfaces/card/Card'
import CardContent from 'atoms/surfaces/card/CardContent'
import Typography from 'atoms/display/Typography'
import DateText from 'atoms/display/DateText'
import CardMedia from 'atoms/surfaces/card/CardMedia'
import { createStyles, makeStyles } from '@material-ui/core/styles'

export type EventCardProps = {
  item: { data: any }
}

const useStyles = makeStyles(theme => createStyles({
  eyeCatchingCard: {
    margin: 'auto',
    width: '90%',
    [theme.breakpoints.up('sm')]: {
      width: '60%'
    },
    [theme.breakpoints.up('md')]: {
      width: '50%'
    }
  },
  eyeCatching: {
    height: '10rem',
    [theme.breakpoints.up('sm')]: {
      height: '15rem'
    },
    [theme.breakpoints.up('md')]: {
      height: '20rem'
    }
  }
}))

export default function EventCard ({
  item
}: EventCardProps) {
  const classes = useStyles()
  const { data } = item

  return (
    <Card>
      <CardContent>
        <RichTitle content={data.title}/>
        <Typography align='right' variant='body2'>
          <DateText dateString={data.date} type='jp-date'/>
        </Typography>
        { data.eye_catching.url && (
          <Card variant="outlined" className={classes.eyeCatchingCard}>
            <CardMedia
              image={data.eye_catching.url}
              className={classes.eyeCatching}
            />
          </Card>
        ) }
        <RichMultiText content={data.contents}/>
      </CardContent>
    </Card>
  )
}
